<template>   
  <div class="col-md-12">
    <barra-navegacao :visiblebutton="true"/>
    <b-row class="text-center">
        <b-col cols="12">          
          <div style="margin-bottom:10px"></div>
            
            <div style="margin: 10px"></div>
              <b-card bg-variant="light" style="min-height: 60vh;">
                <div class="col-md-12">                   
                    <div class="overflow-auto">
                      <b-table stacked="md" id="my-table" striped small :fields="fields" :items="andares" responsive="sm">
                        <template  v-slot:cell(codigo)="data">
                           <span>{{data.item.idAndar}}</span>                                         
                        </template>
                        <template  v-slot:cell(visualizar)="data">
                            <b-button @click="visualizar(data.item.idAndar)" class="v-button" size="sm" style="background-color: #303f9f; margin-right: 5px"><b-icon icon="search"></b-icon></b-button>                                         
                            <b-button @click="remover(data.item.idAndar)" class="v-button" size="sm" variant="danger"><b-icon icon="trash"></b-icon></b-button>                                                                                  
                        </template>
                      </b-table>
                      <div style="float: right">
                      </div>                      
                    </div>
                </div>
              </b-card>
              <br>
              <b-card bg-variant="light">
                <div class="row" style="float: right">
                    <b-button v-b-modal.modal-andar style="margin-right: 30px; background-color: #303f9f">
                      <b-icon icon="file-earmark"></b-icon>  Novo
                    </b-button>   
                </div>
              </b-card>
        </b-col>
      </b-row>
      <b-modal id="modal-andar" ref="modal" title="Andar" @hidden="resetModal" @ok="salvar" >
                <b-form-group label="Descrição" label-for="name-input"  >
                    <b-input id="name-input" v-model="andar.descricao" ></b-input>
                </b-form-group>
        </b-modal>  
    </div>
</template>

<script>
import BarraNavegacao from '../../components/BarraNavegacao.vue';

export default {
  components: { BarraNavegacao },

  data(){
    return{
      andares: [],
      fields: ['descricao',{ key: 'visualizar', label: 'Visualizar' , class:'text-center'}],
      andar: {idAndar: null, descricao: '', status: 'A'}
    }
  },

  created(){
    this.validaAcesso();
  },

  mounted(){
    this.listar();
  },

  methods: {

    alertaMensager(mensagem,titulo,tipo){
          this.$fire({
              title: titulo,
              text: mensagem,
              type: tipo,
              }).then(r => {
               r.value;
            });
        },

    resetModal() {
        this.andar= {idAndar: null, descricao: '', status: 'A'}
    },

    salvar(){
        this.$http.post('/andar', this.andar).then(res => {
             this.alertaMensager(res.data,"","success");   
             this.listar();      
          })
    },

    validaAcesso(){
        this.$http.get('/gerencia', this.sala).then();
    },

    listar(){
      this.$http.get("/andar").then(res => {
         this.andares = res.data;
      }) 
    },

    visualizar(id){
      this.$http.get("/andar/"+id).then(res => {
         this.andar = res.data;
         this.$bvModal.show('modal-andar');
      }) 
    },

    remover(id){
        this.$confirm("Tem certeza que deseja excluir o andar ?").then(() => {
            this.$http.delete("/andar/"+id).then(res => {
                if(res.status == 200){
                    this.alertaMensager("",res.data,"success");
                }else{
                    this.alertaMensager("",res.data,"error");
                }
            }) 
        });
      
    }
    
  }
}

</script>

<style>

</style>
